'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  InfluencerClosetModel,
  InfluencerProductCardModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'

import NewProductCard from '../ProductCard/NewProductCard'
import useSlider from '../../../../hooks/useSlider'

type Props = { data: InfluencerClosetModel }

export const NewClosetSection = ({ data: { title, productList, ctaText, ctaUrl } }: Props) => {
  const { track } = useTracking()
  const { itemRefs, handleOnTouchStart, handleOnTouchMove, handleOnTouchEnd, wrapperDivRef } =
    useSlider({ childData: productList })

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.FollowClosetCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  const renderSlider = (data: Array<InfluencerProductCardModel>) => (
    <div
      className="influencer-v2__closet-cards-wrapper"
      ref={wrapperDivRef}
      onTouchMove={handleOnTouchMove}
      onTouchStart={handleOnTouchStart}
      onTouchEnd={handleOnTouchEnd}
    >
      {data.map((props, index) => (
        <div
          ref={itemRefs[index]}
          className="influencer-v2__closet-slider-wrapper-item"
          key={index}
        >
          <NewProductCard key={index} {...props} testId={`closet-section-card-${index}`} />
        </div>
      ))}
    </div>
  )

  return (
    <section data-testid="closet-section" className="influencer-v2__closet-section">
      <h2 className="influencer-v2__closet-title">{title}</h2>
      {renderSlider(productList)}
      <div className="influencer-v2__closet-cta-wrapper">
        <div className="influencer-v2__closet-cta">
          <Button
            styling="filled"
            text={ctaText}
            testId="closet-section-cta"
            onClick={handleOnCtaClick}
            url={ctaUrl}
          />
        </div>
      </div>
    </section>
  )
}
